"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return Date.now();
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/kryfe-lib/es/utils/getTimestamp.js
// module id = kwj9
// module chunks = 4